import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import DevicesIcon from '@mui/icons-material/Devices';
import FavoriteIcon from '@mui/icons-material/Favorite';

import bgImage from '../assets/images/home-page-bg.jpg';
import logo from '../assets/images/iChocChipLogo.png';

export default function AboutPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.7)), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <Paper
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            boxShadow: 3,
            backgroundColor: '#ffffff',
          }}
        >
          <img
            src={logo}
            alt="ChocChip Studios"
            style={{
              height: 200,
              borderRadius: 4,
              marginBottom: 24,
            }}
          />
          <Typography variant="h3" fontWeight={700} gutterBottom>
            About ChocChip Studios
          </Typography>

          <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 4 }}>
            ChocChip Studios is a small but mighty app and web development studio
            focused on building meaningful digital experiences. We're passionate about
            creating tools that are both powerful and easy to use — with a particular
            love for football, community projects, and indie tech.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h5" fontWeight={600} gutterBottom>
            Our Work
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <SportsSoccerIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary="Non League Live"
                secondary="Our flagship app, giving fans real-time updates, scores, fixtures, and league tables for grassroots football."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <DevicesIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary="Web & Mobile Development"
                secondary="From idea to deployment — we design, build, and ship modern apps using React Native, Node.js, PostgreSQL and more."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <FavoriteIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary="Community Driven"
                secondary="We actively listen to users and develop around real needs — especially within underrepresented or underserved spaces."
              />
            </ListItem>
          </List>

          <Typography variant="h5" fontWeight={600} mt={5} gutterBottom>
            Why ChocChip Studios?
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
            We believe great digital tools shouldn’t be reserved for big brands. We aim
            to bring the same polish and functionality to niche audiences, like local
            football fans and grassroots clubs. Non League Live is just the start — we
           ’re always cooking up new features and new ideas.
          </Typography>

          <Typography variant="h6" mt={4} sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
            ⚽ Built with hard work, passion & care.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
